import { render, staticRenderFns } from "./EditDashboard.vue?vue&type=template&id=3f36f8c4&"
import script from "./EditDashboard.vue?vue&type=script&lang=ts&"
export * from "./EditDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports